import {AvdbCartItemJSON} from "cart-shared";
import {CartItem} from "purchasing/cart/cart-item";
import {AvdbPricingProduct} from "./database-pricing/avdb-pricing-product";
import {Money} from "money";
import {jsonProperty} from "json-mapper-reflect";
import * as JSONMapper from "json-mapper";
import {CartDevice} from "./cart-device";


export class AvdbCartItem extends CartItem {
	constructor(data?: Partial<AvdbCartItem>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty(JSONMapper.classByMethods(CartDevice))
	device: CartDevice;
	@jsonProperty(JSONMapper.classByMethods(AvdbPricingProduct))
	product: AvdbPricingProduct;
	private _futureStartDate?: Date;

	//These fields are only available on read. They come from the order service.
	@jsonProperty()
	orderPrice: Money;
	@jsonProperty()
	orderProductName: string;
	@jsonProperty()
	orderPartNumber: string;

	get price() {
		return this.product.price;
	}

	get partNumber() {
		return this.product.partKey;
	}

	get futureStartDate() {
		return this._futureStartDate;
	}

	toJSON(): AvdbCartItemJSON {
		return {
			itemType: "avdb",
			partNumber: this.partNumber,
			deviceID: this.device.id,
			futureStartDate: this.futureStartDate
		};
	}
}
